import { $dt, definePreset, palette } from '@primeng/themes';
import material from '@primeng/themes/material';

export const EboTheme = definePreset(material, {
  //Your customizations, see the following sections for examples
  semantic: {
    primary: palette('#3f51b5'),
    surface: palette('gray'),
    colorScheme: {
      light: {
        primary: {
          color: '{primary.500}',
          contrastColor: '{surface.50}'
        },
        link: {
          color: '{indigo-500}'
        },
        surface: {
          color: '{surface.50}',
          b: {
            color: '{surface.100}'
          },
          c: {
            color: '{surface.200}'
          },
          d: {
            color: '{surface.300}'
          }
        },
        border: {
          color: '{surface.500}'
        },
        grid: {
          overflow: {
            color: '{surface.300}',
            contrastColor: '{text-color}'
          },
          group: {
            0: {
              color: '#008cff',
              contrastColor: '{text-color}'
            },
            1: {
              color: 'cyan',
              contrastColor: '{text-color}'
            },
            2: {
              color: 'lightskyblue',
              contrastColor: '{text-color}'
            },
            3: {
              color: 'lightsteelblue',
              contrastColor: '{text-color}'
            },
            4: {
              color: 'steelblue',
              contrastColor: '{text-color}'
            }
          }
        },
        highlight: {
          color: 'black',
          background: '{yellow.600}',
          border: {
            color: '{yellow.600}'
          }
        },
        flag: {
          color: '{text-color}',
          background: '{blue.600}',
          border: {
            color: '{blue.600}'
          }
        },
        warning: {
          color: '{text-color}',
          background: '{orange.700}',
          border: {
            color: '{orange.700}'
          }
        },
        danger: {
          color: 'white',
          background: '{red.600}',
          border: {
            color: '{red.600}'
          }
        },
        'grey-out': {
          color: 'white',
          background: '{neutral.300}'
        },
        darkened: {
          color: 'white',
          background: '{neutral.400}'
        }
      },
      dark: {
        primary: {
          color: '{primary.800}',
          contrastColor: '{surface.300}'
        },
        link: {
          color: '{blue-500}'
        },
        surface: {
          color: 'black',
          b: {
            color: '{surface.950}'
          },
          c: {
            color: '{surface.900}'
          },
          d: {
            color: '{surface.800}'
          }
        },
        border: {
          color: '{surface.500}'
        },
        grid: {
          overflow: {
            color: '{surface.900}',
            contrastColor: '{surface.100}'
          },
          group: {
            0: {
              color: '{slate.600}',
              contrastColor: '{text-color}'
            },
            1: {
              color: '{slate.700}',
              contrastColor: '{text-color}'
            },
            2: {
              color: '{slate.800}',
              contrastColor: '{text-color}'
            },
            3: {
              color: '{slate.900}',
              contrastColor: '{text-color}'
            },
            4: {
              color: '{slate.950}',
              contrastColor: '{text-color}'
            }
          }
        },
        highlight: {
          color: 'black',
          background: '{yellow.500}',
          border: {
            color: '{yellow.500}'
          }
        },
        flag: {
          color: '{text-color}',
          background: '{blue.500}',
          border: {
            color: '{blue.500}'
          }
        },
        warning: {
          color: '{text-color}',
          background: '{orange.900}',
          border: {
            color: '{orange.900}'
          }
        },
        danger: {
          color: '{text-color}',
          background: '{red.900}',
          border: {
            color: '{red.900}'
          }
        },
        'grey-out': {
          color: '{neutral.600}',
          background: '{neutral.800}'
        },
        darkened: {
          color: '{neutral.400}',
          background: '{neutral.700}'
        }
      }
    }
  },
  components: {
    autocomplete: {
      colorScheme: {
        light: {
          option: {
            selected: {
              color: 'inherit',
              background: '{surface.200}'
            }
          }
        },
        dark: {
          option: {
            selected: {
              color: 'white',
              background: '{surface.900}'
            }
          }
        }
      }
    },
    button: {
      colorScheme: {
        light: {
          primary: {
            border: {
              color: '{primary.500}'
            }
          },
          text: {
            primary: {
              color: '{primary.500}'
            }
          },
          success: {
            color: 'white',
            background: '{green.500}'
          },
          info: {
            color: '{sky-950}',
            background: '{sky-200}'
          }
        },
        dark: {
          primary: {
            border: {
              color: '{primary.400}'
            }
          },
          text: {
            primary: {
              color: '{primary.400}'
            }
          },
          success: {
            color: 'white',
            background: '{green.500}'
          },
          info: {
            color: '{sky-400}',
            background: '{sky-950}'
          },
          outlined: {
            primary: {
              color: '{primary.400}',
              border: {
                color: '{primary.400}'
              }
            }
          }
        }
      }
    },
    card: {
      colorScheme: {
        light: {
          background: '{surface.0}',
          color: 'currentColor'
        },
        dark: {
          background: '{surface.900}',
          color: 'currentColor',
          shadow:
            '0 2px 1px -1px rgba(255,255,255,.2), 0 1px 1px 0 rgba(255,255,255,.14), 0 1px 3px 0 rgba(255,255,255,.12)'
        }
      },
      body: {
        padding: '0.5rem 1.5rem 1.5rem 1.5rem'
      }
    },
    dialog: {
      colorScheme: {
        light: {
          root: {
            background: '{surface.0}',
            color: 'black'
          }
        },
        dark: {
          root: {
            background: '{surface.900}',
            color: 'currentColor'
          }
        }
      }
    },
    divider: {
      colorScheme: {
        light: {
          content: {
            color: 'inherit',
            background: '{surface.0}'
          }
        },
        dark: {
          content: {
            color: 'white',
            background: '{surface.900}'
          }
        }
      }
    },
    fieldset: {
      colorScheme: {
        light: {
          background: 'transparent',
          color: 'currentColor',
          legend: {
            background: '{surface.0}'
          }
        },
        dark: {
          background: 'transparent',
          color: 'currentColor',
          legend: {
            background: '{surface.900}'
          }
        }
      },
      legend: {
        border: {
          color: '{surface.500}'
        },
        color: 'currentColor'
      }
    },
    fileupload: {
      colorScheme: {
        light: {
          background: '{surface.0}',
          color: 'currentColor',
          header: {
            color: 'currentColor'
          }
        },
        dark: {
          background: '{surface.900}',
          color: 'currentColor',
          header: {
            color: 'currentColor'
          }
        }
      }
    },
    floatlabel: {
      colorScheme: {
        light: {
          color: '{surface.500}',
          active: {
            color: '{surface.800}'
          },
          on: {
            active: {
              background: '{surface.0}'
            }
          }
        },
        dark: {
          color: '{surface.500}',
          active: {
            color: '{surface.200}'
          },
          focus: {
            color: '{surface.200}'
          },
          on: {
            active: {
              background: '{surface.800}'
            }
          }
        }
      }
    },
    inputtext: {
      invalid: {
        border: {
          color: $dt('red.500').value
        }
      },
      colorScheme: {
        light: {
          background: '{surface.0}',
          color: 'black',
          disabled: {
            background: '{surface.200}'
          }
        },
        dark: {
          background: '{surface.900}',
          color: 'currentColor',
          disabled: {
            background: '{surface.700}'
          }
        }
      }
    },

    panel: {
      colorScheme: {
        light: {
          background: '{surface.0}'
        },
        dark: {
          background: '{surface.900}'
        }
      }
    },
    progressbar: {
      height: '4px',
      colorScheme: {
        light: {
          background: '{surface.200}'
        },
        dark: {
          background: '{surface.900}'
        }
      }
    },
    progressspinner: {
      color: {
        '1': $dt('red.500').value,
        '2': $dt('red.500').value,
        '3': $dt('red.500').value,
        '4': $dt('red.500').value
      }
    },
    splitter: {
      colorScheme: {
        light: {
          background: '{surface.0}',
          color: 'currentColor'
        },
        dark: {
          background: '{surface.900}',
          color: 'currentColor'
        }
      }
    },

    tabs: {
      tab: {
        color: 'currentColor'
      },
      tablist: {
        background: '{surface-b}'
      },
      tabpanel: {
        background: '{surface-b}',
        color: 'currentColor',
        padding: '0.5rem 1.5rem 1.5rem 1.5rem'
      }
    },
    tieredmenu: {
      colorScheme: {
        light: {
          background: '{surface.100}',
          color: 'black',
          item: {
            color: 'black'
          }
        },
        dark: {
          background: '{surface.950}',
          color: 'white',
          item: {
            color: 'white'
          }
        }
      }
    },
    tree: {
      colorScheme: {
        light: {
          color: 'black',
          icon: {
            color: 'inherit'
          },

          background: '{surface.0}',
          node: {
            color: 'black',
            content: {
              color: 'inherit',
              background: '{surface.0}'
            },
            selected: {
              color: 'inherit',
              background: '{surface.200}'
            }
          }
        },
        dark: {
          color: 'white',
          icon: {
            color: 'inherit'
          },
          background: 'black',
          node: {
            color: 'white',
            content: {
              color: 'white',
              background: 'black'
            },
            selected: {
              color: 'white',
              background: '{surface.900}'
            }
          }
        }
      }
    },
    csp: {
      nonce: '123456'
    }
  }
});
